import PermissionService from "@services/PermissionService";

const PermissionModule = (() => {
	const permissionService = new PermissionService();
	let modulePermissionsCache = null;
	let permissions = [];

	const fetchPermissions = async () => {
		try {
			const response = await permissionService.userPermissions();
			if (response.data.userType !== "student") {
				permissions = response.data;
			}
		} catch (error) {
			// Handle the error appropriately
			console.error("Error fetching permissions:", error);
		}
		return permissions.map(({ meta_key, meta_value }) => ({
			[meta_key]: meta_value,
		}));
	};

	const hasPermission = (metaKey) => {
		return permissions.some(
			(permission) =>
				permission.meta_key === metaKey &&
				permission.meta_value?.toLowerCase() === "yes",
		);
	};

	const hasModule = async (module) => {
		if (!modulePermissionsCache) {
			try {
				const permission = await permissionService.userModulePermission(module).then((response) => { return response.data; });
				if (permission === 'active') {
					return true;
				} else if (permission === 'block') {
					return false;
				} else if (permission.userType === "student") {
					return false;
				} else {
					console.error("Error: incorrect data received: ");
				}
			} catch (error) {
				// Handle the error appropriately
				console.error("Error fetching module permissions:", error);
			}
		}
		console.log(modulePermissionsCache);
		return modulePermissionsCache?.toLowerCase() === "active";
	};

	const canSeeNote = (note) => {
		const { add_user_id } = note;
		if (note.type_id == 3) {
			if (current_user_id === add_user_id) {
				if (hasPermission("is_confidential_journal")) return true;
			} else {
				if (hasPermission("is_confidential_other_journal")) return true;
			}
			return false;
		} else {
			return true;
		}
	};

	return {
		fetchPermissions,
		hasPermission,
		hasModule,
		canSeeNote,
	};
})();

export default PermissionModule;
